import { Col, Input, Label, Row } from "reactstrap";
import { CommonFormGroupProp } from "../../../../../Type/CommonComponant";

const CommonFormGroup = ({ labelClass, label, colSm, colClass, inputType, placeholder, defaultValue,inputClass,max }: CommonFormGroupProp) => {
  return (
    <Row className="mb-3 align-items-center">
      <Label className={`col-sm-3 ${labelClass}`} check>{label}</Label>
      <Col sm={colSm} className={colClass}>
        <Input type={inputType} className={inputClass} placeholder={placeholder} defaultValue={defaultValue} max={max}/>
      </Col>
    </Row>
  );
};

export default CommonFormGroup;
